export enum Role {
  All = "All",
  Owner = "Owner",
  Admin = "Admin",
  Doctor = "Doctor",
  Staff = "Staff",
  Client = "Client",
  Patient = "Patient",
}
